@if (content$ | async; as content) {
  <div>
    <h1 class="text-center">{{ content.heading }}</h1>
    <div class="text-center" [innerHtml]="content.body" ></div>
  </div>
}